import styled from "styled-components";

import PageWrapper from "Components/Pages/Wrapper";

export const PageContainer = styled(PageWrapper)`
  padding-top: 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
`;

export const PageContent = styled.div`
  flex: 1;
  height: 100%;
  display: grid;
  grid-template-rows: 132px minmax(400px, 1fr) auto;
`;

export const PageHeading = styled.div`
  grid-row: 1/2;
  grid-column: 1/2;
  width: auto;
`;

export const PageBody = styled.div`
  padding: 0 20px 0px;
  grid-row: 1/3;
  grid-column: 1/3;

  display: grid;
  grid-template-rows: 132px 1fr;
  grid-template-columns: 1fr 371px;

  .card-search-information {
    padding-right: 20px;
    grid-column: 1/2;
    grid-row: 2/3;
    margin: 0;
  }

  .cart-information {
    grid-column: 2/3;
    grid-row: 1/3;

    border-top: none;
    padding: 20px 20px;
    border-left: 1px solid #c4c4c4;
    position: unset;
    width: auto;
    padding-right: 0;
  }

  @media (min-width: 1600px) {
    grid-template-columns: 1fr 550px;
  }
`;

export const TableItemStyle = styled.tr`
  button {
    border: unset;
    padding: 0;
    background: none;
    cursor: pointer;
  }

  .disabled {
    cursor: default;
  }
`;

export const ButtonsHolder = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 30px;
  width: 100%;
  max-width: 500px;
  margin: 40px auto 0;
  justify-content: center;
`;
